import script from "./ItemView.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemView.vue?vue&type=script&setup=true&lang=js"

import "./ItemView.vue?vue&type=style&index=0&id=e9c50f86&scoped=true&lang=css"

import exportComponent from "C:\\fukunocha\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9c50f86"]])

export default __exports__